<template>
  <modal
    width="35"
    id="decline"
    :show-modal="showModal"
    @close-modal="$emit('close-modal', 'decline')"
  >
    <div class="delete-modal">
      <div class="flex justify-center">
        <img
          src="@/assets/images/icons/new-delete.svg"
          alt="Delete illustration"
          class="img-fluid"
        />
      </div>

      <div class="my-6">
        <p>Are you sure you want to decline this assigned shipment?</p>
      </div>

      <div>
        <base-button :loading="loading" @click="declineBooking()" text="Yes, Decline" />
      </div>
    </div>
  </modal>
</template>

<script>
// import DeleteIcon from "../NewBooking/Modals/DeleteConsigneeModalIcon";

export default {
  components: {
    // DeleteIcon,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    reason: {
      type: String,
      required: true,
    },
    booking: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      id: "decline",
      loading: false,
      showDeclineReasonModal: false,
    };
  },
  methods: {
    async declineBooking() {
      try {
        this.loading = true;
        await this.$_updateShippingStatusByDriver(this.booking.id, {
          deliveryStatus: "declined",
          message: this.reason,
        });
        this.generateToast("Booking Declined!", "success");
        this.loading = false;
        // this.resetInputFied();
        this.$emit("booking-subaction-completed");
        this.$emit("close-modal", this.id);
        // this.closeModal()
      } catch (error) {
        this.loading = false;
        this.handleError(error);
      }
    },
    closeModal() {
      this.showDeclineReasonModal = true;
      this.$emit("close-modal", "decline");
    },
  },
};
</script>

<style scoped>
.delete-modal {
  text-align: center;
}
</style>
